import {
  supportAnalyticsInputSchema,
  supportAnalyticsOutputSchema,
} from "@redotech/redo-support-common/support/analytics/support-analytics-schemas";

export const supportAnalytics = {
  name: "supportAnalytics" as const,
  input: supportAnalyticsInputSchema,
  output: supportAnalyticsOutputSchema,
};
